
// Si estamos en desarrollo estas variables se configurarán aquí, en caso de haber hecho build
// estas variables se definen en el index.php
if (process.env.NODE_ENV === 'development') {
  window.codigoPromocion = 1300
  window.codigoActivo = 2754
  // window.codigoPromocion = 4376
  // window.codigoActivo = 1651
  window.numOportunidad = 200
  window.idubapi = '1002100101'
  window.codSubdominioAgrupacion = 'desdemo'
  window.errorSubdominioAgrupacion = false
  window.mostrarBoton = false
  window.errorUsuarioComercial = 0
  window.usuarioComercial = null
  window.datosContacto = null
  // window.usuarioComercial = {
  //   usuario: 'A-TOL-TOL',
  //   email: ''
  // }
  // window.datosContacto = {
  //   "tipoPersona": "F", // [F=Física, J=Jurídica]
  //   "nombre": "MARÍA", // [Si es Jurídica en “nombre” vendrá la Razón Social]
  //   "apellidos": "RINCÓN GARCÍA", 
  //   "tipoDocumento": "N", // [Vendrá con: C,N,P,T , Y. Se indica mapeo para CD: C=C, N=N, P=P, T=T, Y=O. Si es Jurídico, forzaremos C, con independencia de este valor ]
  //   "documento": "31045045G",
  //   "fechaNacimiento": "31/12/1980",
  //   "sexo": "M", // [M=Mujer, H=Hombre]
  //   "estadoCivil": "S", // [Debe de coincidir con el maestro vd_estadosCiviles. Cualquier valor distinto no lo consideraremos]
  //   "nacionalidad": "11",  // [Debe de coincidir con el maestro vd_nacionalidades. Cualquier valor distinto no lo consideraremos]
  //   "sigla": null,  // [Debe de coincidir con el maestro vd_tiposVia. Cualquier valor distinto no lo consideraremos]
  //   "domicilio": null,
  //   "numero": null,
  //   "escalera": null,
  //   "piso": null, 
  //   "puerta": null, // [Los datos domicilio, numero, escalera y piso se concatenarán en vd_compradores.domicilio]
  //   "pais": "11", // [Es país de residencia.  Debe de coincidir con el maestro vd_paises. Cualquier valor distinto no lo consideraremos]
  //   "provincia": "28", // [Debe de coincidir con el maestro vd_provincias. Cualquier valor distinto no lo consideraremos]
  //   "poblacion": "MADRID", 
  //   "codigoPostal": "28021",
  //   "telefono": "600121212", // [Lo podemos usar como teléfono del cliente en CD si el “móvil” viene vacío]
  //   "telefono2": null, // [Lo podemos usar como teléfono del cliente en CD si el “móvil”  y el “teléfono” viene vacío]
  //   "movil": null, // [Lo usaremos como primera opción como teléfono del cliente en CD ]
  //   "fax": null, // [No tiene cabida en CD pero se enviará, por si a futuro hiciera falta]
  //   "email": null, // [Esto debería  ser un dato obligatorio, ya que servirá para localizar el actor o crear uno nuevo. No obstante podría venir vacío. En este caso se tiene que permitir informarlo en el formulario de Soy Cliente/Registrarse]
  //   "proteccionDatos": false // [No tiene cabida en CD pero se enviará, por si a futuro hiciera falta]
  // }
  window.theme = {
    primary: '#4c82c0',
    secondary: '#ddecff',
    overSecondary: '#4c82c0',
    titleColor: '#fb8d96'
  }
  window.idioma_defecto = 'spa'
  window.idiomas = ['spa','eng']
}


// WEBPACK FOOTER //
// ./src/plugins/variablesWindow.js